<template>
	<div class="popup" v-if="isAgree">
	  <div class="popup-overlay" @click="closePopup"></div>
	  <div class="popup-content" @click.stop>

		<div class="content-area" v-html="popupMessage"></div>
		<header>
			<button class="agreen_btn" @click="closePopup">同意</button>
		</header>
	  </div>
	</div>
  </template>

<script>
  export default {
	props: ['isAgree', ''],
    data() {
      return {
		isPopupVisible: false,
		popupMessage: `<div><p style="background-color:#ffffff; margin:0pt"><span style="font-family:宋体; font-size:13.5pt; font-weight:bold">会员（嘉友）加入须知：</span></p><p style="background-color:#ffffff; margin:0pt"><br /><span style="font-family:宋体; font-size:13.5pt">关于嘉友荟：</span></p><p style="background-color:#ffffff; margin:0pt"><span style="font-family:宋体; font-size:13.5pt">嘉友荟是为追求健康生活、热衷环境保护的中国消费者量身打造的高端消费者俱乐部。</span><br /><span style="font-family:宋体; font-size:13.5pt">嘉友荟为嘉友们搭建了一个健康交流的平台和拥有共同价值观的人际交流圈。</span><br /><span style="font-family:宋体; font-size:13.5pt">同时也可以帮助您身边的每一个人尽享健康生活，共建绿色健康的地球家园。</span><br /><span style="font-family:宋体; font-size:13.5pt">嘉友荟助您搭建更加广泛的人际社交网络</span></p><p style="background-color:#ffffff; margin:0pt"><span style="font-family:宋体; font-size:13.5pt">如何成为嘉友：</span></p><p style="background-color:#ffffff; margin:0pt"><span style="font-family:宋体; font-size:13.5pt">年满</span><span style="font-family:Tahoma; font-size:13.5pt">18</span><span style="font-family:宋体; font-size:13.5pt">岁的公民，购买任意嘉康利产品（辅销品除外），提供有效身份证号，填写嘉友入会申请表并提交，即可成为嘉友</span></p><p style="background-color:#ffffff; margin:0pt"><span style="font-family:宋体; font-size:13.5pt">嘉友权益：</span></p><p style="background-color:#ffffff; margin:0pt"><span style="font-family:宋体; font-size:13.5pt">忠诚顾客优</span><span style="font-family:Tahoma; font-size:13.5pt">+</span><span style="font-family:宋体; font-size:13.5pt">计划</span><span style="font-family:Tahoma; font-size:13.5pt">—</span><span style="font-family:宋体; font-size:13.5pt">参与忠诚顾客优</span><span style="font-family:Tahoma; font-size:13.5pt">+</span><span style="font-family:宋体; font-size:13.5pt">计划，持续消费，积累积分，积分可兑换商品，请详见《</span><a style="color:#000000" href="https://www.shaklee.com.cn/NewMBST/images/upload/File/%E5%BF%A0%E8%AF%9A%E9%A1%BE%E5%AE%A2%E4%BC%98+%E8%AE%A1%E5%88%92.jpg" target="_blank"><span style="font-family:宋体; font-size:13.5pt; font-weight:bold; text-decoration:underline">忠诚顾客优</span><span style="font-family:Tahoma; font-size:13.5pt; font-weight:bold; text-decoration:underline">+</span><span style="font-family:宋体; font-size:13.5pt; font-weight:bold; text-decoration:underline">计划</span></a><span style="font-family:宋体; font-size:13.5pt">》</span><br /><span style="font-family:宋体; font-size:13.5pt">推荐其他嘉友</span><span style="font-family:Tahoma; font-size:13.5pt">—</span><span style="font-family:宋体; font-size:13.5pt">（如您本人没有填写培训员则不能享有此项权益）</span><br /><span style="font-family:宋体; font-size:13.5pt">身份转为经销商</span><span style="font-family:Tahoma; font-size:13.5pt">—</span><span style="font-family:宋体; font-size:13.5pt">（如您本人没有填写培训员则不能享有此项权益）</span></p><p style="background-color:#ffffff; margin:0pt"><span style="font-family:宋体; font-size:13.5pt">嘉友身份终止：</span></p><p style="background-color:#ffffff; margin:0pt"><span style="font-family:宋体; font-size:13.5pt">自嘉友身份确认之日起，如有连续二十四个月未购货，则自第二十五月起嘉友身份终止，如需恢复，则需重新办理加入。</span></p><p style="background-color:#ffffff; margin:0pt"><span style="font-family:Tahoma; font-size:13.5pt">&#xa0;</span></p><p style="background-color:#ffffff; margin:0pt"><span style="font-family:宋体; font-size:13.5pt; font-weight:bold">本人自愿申请，保证所填写内容、所提交资料、真实有效。本人已完整阅读且充分了解嘉友申请标准及嘉友相关权益等公司各项规章制度和业务政策，并承诺将严格遵行。如违反上述承诺、保证事项，本人自愿承担因此而对其本人所产生的一切不利后果及法律责任。</span></p><p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span style="font-family:等线; font-size:10.5pt">&#xa0;</span></p></div>`
      }
    },
	methods: {
		closePopup() {
			this.$emit('close');
		}
	}
  }
</script>

<style scoped>
  .popup-title {
	text-align: center;
  }
  .popup {
	position: fixed;
	top: 1%;
	left: 2%;
	width: 96%;
	height: 85%; /* 设置弹窗高度为屏幕高度 */
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	color:black;
	text-align: left;
	line-height:1.5;
	min-width: 340px;
	min-height: 95%;
  }
  
  .popup-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 90%;
	z-index: 1;
  }
  
  .popup-content {
	background-color: white;
	padding: 10px;
	border-radius: 5px;
	max-width: 100%;
	min-width: 300px; /* 最小宽度 */
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
	position: relative;
	z-index: 2;
	display: flex;
	flex-direction: column;
	height: 92%; /* 设置内容区域高度 */
  }
  
  header {
  	display: flex;
  	justify-content: space-between;
  	align-items: center;
  	margin-bottom: 10px;
  }
  
  .content-area {
	flex-grow: 1; /* 内容区域扩展至可用空间 */
	overflow-y: auto; /* 当内容超出时显示垂直滚动条 */
	max-height: calc(100% - 50px); /* 减去头部的高度 */
	padding: 5px 0;
  }
  
  .agreen_btn {
	margin-top: 5px;
	width: 100%;
	height: 45px;
	border-radius: 25px;
	border: none;
	background-color: #173f35;
	color: #fff;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/MbstPrivacyPopup.vue